import { Api } from "./_base";

export const loadAppConfig = async (): Promise<any> => {
  return Api.execute({ url: `/api/fe-config` });
};
